const Analytics = {
	sendVirtualPageview(viewSection: string, viewName: string): void {
		const defaultData = {
			'event': 'sendVirtualPageview',
			'viewSection': '(not set)', 
			'viewName': '(not set)'
		};
		this.pushDataLayer(defaultData, {
			'viewSection': viewSection,
			'viewName': viewName
		});
	},
	sendSuccessfulOrderComplete(data: any): void {
		const defaultData = {
			'event': 'grYarisOrder',            // hardcoded value of 'reserve'
			'eventLabel': 'order',          // hardcoded value of 'Preference 1'
			'vehicleModel': 'GR Yaris',               // static value
			'vin': '(not set)',                    // static value
			'vehicleGrade': '<dynamic value>',     // Value of grade
			'vehicleGradeVariation': '(not set)',  // static value
			'vehicleType': '(not set)',            // static value
			'vehicleColour':'<dynamic value>',     // Value of colour
			'vehicleTrim': '<dynamic value>',      // Value  of trim
			'vehicleTransmission': '(not set)',    // static value.
			'vehicleDesc': '<dynamic value>',      // add if available
			'vehicleFactoryOptDesc': '(not set)',  // static value
			'vehicleOnSpecial': '(not set)',       // static value
			'vehiclePrice': '<dynamic value>',     // Value displayed (if available) for combination
			'vehicleMaterialCode': '(not set)',    // static value
			'vehicleMake': 'Toyota',               // static value
			'vehicleYear': '<dynamic value>',      // The year of the model
			'tradeInIsOlderEnquiry': '(not set)',  // static value
			'orderId': '<dynamic value>'             //An ID that is linked to this order
		};
		this.pushDataLayer(defaultData, data);
	},
	sendSuccessfulOrder(data: any): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Submission',  
			'eventAction': 'reserve successful', 
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          //  0
			'nonInteraction': false,   // (boolean)
			'orderId': '<dynamic value>', //An ID that is linked to this order
			'dealerName': '<dynamic value>'
		};
		this.pushDataLayer(defaultData, data);
	},
	sendVehiclePreference(data: any): void {
		const defaultData = {
			'event': 'grYarisPreference',            // hardcoded value of 'reserve'
			'eventLabel': '',          // hardcoded value of 'Preference 1'
			'vehicleModel': 'GR Yaris',     // static value
			'vin': '(not set)', // static value
			'vehicleGrade': '<dynamic value>',     // Value selected in dropdown for preference 1
			'vehicleGradeVariation': '(not set)',  // static value
			'vehicleType': '(not set)',            // static value
			'vehicleColour':'<dynamic value>',     // Value selected in dropdown for preference 1
			'vehicleTrim': '<dynamic value>',      // Value selected in dropdown for preference 1
			'vehicleTransmission': '(not set)',    // static value.
			'vehicleDesc': '<dynamic value>',      // add if available
			'vehicleFactoryOptDesc': '(not set)',  // static value
			'vehicleOnSpecial': '(not set)',       // static value
			'vehiclePrice': '<dynamic value>',     // Value displayed (if available) for combination
			'vehicleMaterialCode': '(not set)',    // static value
			'vehicleMake': 'Toyota',               // static value
			'vehicleYear': '<dynamic value>',      // The year of the model
			'tradeInIsOlderEnquiry': '(not set)',  // static value
			'orderId': '<dynamic value>'//An ID that is linked to this order
		};
		this.pushDataLayer(defaultData, data);
	},
	sendLogout(): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Submission',  
			'eventAction': 'logout successful', 
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          //  0
			'nonInteraction': false   // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendLogin(): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Submission',  
			'eventAction': 'login successful', 
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          //  0
			'nonInteraction': false   // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendRegisterNow(): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'User Interactions',  
			'eventAction': 'register now', // e.g. Submit, Go to Step 2 etc
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          // (integer)
			'nonInteraction': false   // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendResetPassword(): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'User Interactions',  
			'eventAction': 'reset password', // e.g. Submit, Go to Step 2 etc
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          // (integer)
			'nonInteraction': false   // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendEmailNotFound(): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Submission',  
			'eventAction': 'login failed',
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          // (integer)
			'nonInteraction': false   // (boolean
		};
		this.pushDataLayer(defaultData, null);
	},
	sendButtonClick(eventAction: any): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Interactions',// e.g. (User Interactions|Form Interactions)
			'eventAction': eventAction.toLowerCase(), // e.g. Submit, Go to Step 2 etc
			'eventLabel': '',         // pass empty string
			'eventValue': 0,          // (integer)
			'nonInteraction': false   // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendError(eventLabel: any): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Interactions',// static value
			'eventAction': 'error', // static value
			'eventLabel': eventLabel.toLowerCase(), // The error message shown
			'eventValue': 0, // (integer)
			'nonInteraction': true // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendFieldFocus(eventAction: any): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Interactions',// e.g. (User Interactions|Form Interactions)
			'eventAction': eventAction.toLowerCase(), // e.g. (focused on the first name text field)
			'eventLabel': '', // pass empty string
			'eventValue': 0, // (integer)
			'nonInteraction': false // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	sendFieldChange(eventAction: any, eventLabel: any): void {
		const defaultData = {
			'event': 'sendEvent',
			'eventCategory': 'Form Interactions',// e.g. (User Interactions|Form Interactions)
			'eventAction': eventAction.toLowerCase(), // e.g. (add liability|add asset)
			'eventLabel': eventLabel.toLowerCase(), // pass empty string
			'eventValue': 0, // (integer)
			'nonInteraction': false // (boolean)
		};
		this.pushDataLayer(defaultData, null);
	},
	pushDataLayer(defaultData: any, data: any): void {
		const dataLayer = (window as any).dataLayer || [];
		const newData = data ? {...defaultData, ...data} : defaultData;
		dataLayer.push(newData);
	}
};
export default Analytics;